<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="d-flex flex-row-fluid flex-column flex-lg-row bg-white login login-1 login-signin-on"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div
        class="d-flex flex-row-auto p-10 p-lg-15 bgi-no-repeat bgi-size-cover login-aside"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      >
        <!--begin: Aside Container -->
        <div class="d-flex flex-column justify-content-between">
          <!--begin: Aside header -->
          <a href="/#">
            <img src="media/logos/logo-vert.svg" class="logo" />
          </a>
          <!--end: Aside header -->
          <!--begin: Aside content -->
          <div
            class="d-flex flex-column flex-column-fluid justify-content-center"
          >
            <h3 class="mt-10 mb-5 font-size-h1 text-white">
              Welcome to Innocalls SBC!
            </h3>
            <p class="opacity-80 font-weight-lighter text-white">
              The ultimate voip solution for your business. 100% secure and
              reliable. Let's get started!
            </p>
          </div>
          <!--end: Aside content -->
          <!--begin: Aside footer for desktop -->
          <div
            class="d-lg-flex flex-column-auto justify-content-between mt-15 d-none"
          >
            <div class="opacity-70 font-weight-bold text-white">
              © {{ new Date().getFullYear() }} Innocalls SBC
            </div>
            <!-- <div class="d-flex">
              <a href="#" class="text-white">Privacy</a>
              <a href="#" class="ml-10 text-white">Legal</a>
              <a href="#" class="ml-10 text-white">Contact</a>
            </div> -->
          </div>
          <!--end: Aside footer for desktop -->
        </div>
        <!--end: Aside Container -->
      </div>
      <!--begin::Aside-->

      <!--begin::Content-->
      <div
        class="position-relative d-flex flex-row-fluid flex-column p-7 overflow-hidden"
      >
        <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
          <router-view></router-view>
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  methods: {},
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-5.jpg";
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
</style>
